import { coursePaymentDate, usesClassPayment } from '@/helpers/coursePayment'
import { getBaseRole } from '@/helpers/customRoles';
import classNames from 'classnames'
import { useState } from 'react'
import HeaderPage from '@common/HeaderPage'
import Search from '@UI/Search'
import s from './index.module.css'
import style from "../page.module.css"
import AccrualHistory from './AccrualHistory'
import Button from '@UI/Button'
import Modal from '@common/Modal'
import ExtendTraining from './modal'
import { declOfNum } from '@helpers/declOfNum'
import { useEffect } from 'react'
import { useLoadMore } from '@hooks/useLoadMore'
import { directionOrdersApi } from '@api'
import { useInputNew } from '@UI/InputNew/useInputNew'
import { InputSelect } from '@UI/InputNew'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import Preloader from '@UI/Preloader'
import { getAvatar } from '@helpers/getAvatar'
import { formateDate } from '@helpers/date'
import { useGetDirection } from '@hooks/useGetDirection'
import { getInArr } from '@helpers/getInArr'
import {billingConversion} from "@/helpers/billingConversion";
import {ChangeBalance} from "@pages/Admin/Reports/ContinuingEducation/modal/ChangeBalance";
import SmallCard from "@common/SmallCard";
import Table from "@pages/Admin/Reports/ContinuingEducation/Table/Table";
import {API, settingApi} from "@/api";
import Textarea from "@UI/Textarea";
import {useAddAlert} from "@/hooks/useAddAlert";
import ReportWrapper from '../components/ReportWrapper/ReportWrapper'


const ContinuingEducation = () => {
  // таб
  const [tab, setTab] = useState("List")
  const [tabData, setTabData] = useState({})

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (tabData.id && tab === 'List') setTabData({}) }, [tab])

  const settings = useSelector((store) => store.settings);
  const isUniversalBalance = settings?.isUniversalBalance === '1';

  return <ReportWrapper>
      {tab === 'List' && <List {...{ setTab, isUniversalBalance }} />}
      {tab === 'AccrualHistory' && <AccrualHistory {...{ setTab, order: tabData }} />}
   </ReportWrapper>
}

const List = ({ setTab, isUniversalBalance }) => {
  const profile = useSelector(selectProfile)

  // модальное окно
  const initModal = { active: false, type: '', data: {} }
  const [modal, setModal] = useState(initModal)
  const closeModal = () => setModal(initModal)

  // получение доступных направлений
  const direction = useGetDirection(getInArr(getBaseRole(profile.role), ['seminarian', 'senior-seminarian']))


  // фильтр
  const initFilter = { direction: getInArr(getBaseRole(profile.role), ['seminarian', 'senior-seminarian']) ? direction.select[0]?.value : '' }
  const [filter, setFilter] = useState(initFilter)
  const [isShowTable, setIshShowTable] = useState(false);
  const [bindDirection, reset] = useInputNew({
    value: filter.direction,
    onChange: e => setFilter(prev => ({ ...prev, direction: e })),
    placeholder: 'Направление',
    options: direction.select
  })
  const [showAllRows, setShowAllRows] = useState(false);

  const [search, setSearch] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const bindSearch = {
    value: searchValue,
    onChange: e => setSearchValue(e.target.value)
  }

  const filterOrder = (filter.direction) ? [`[direction_id][eq]=${filter.direction}`] : []

  function loadExcel() {
    const link = document.createElement("a");
    link.target = "_blank";
    API.get(
        'direction/export-debtors',
        { responseType:'arraybuffer',
          }
    ).then((res) => {
      link.href = URL.createObjectURL(
          new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      );
      link.download = 'Должники.xlsx';
      link.click();
    });
  }

  if (search) filterOrder.push(`[search]=${search}`)

  // заказы
  const { state, getState, setState, ref, loading, loadingAll, getNext } = useLoadMore({
    api: directionOrdersApi.get,
    params: { 
      filter: filterOrder,
      expand: ['direction', 'tariff', 'children', 'privateInfo', 'class.classUser'],
      notFree: false,
      allRows: showAllRows,                                                                        
    },
    last: false
  })

  useEffect(()=>{
      let loadingMore = 0;
      for(let i=0; i<(state?.length - 5); i++){
        if((state[state?.length - 5] && state[i]?.class_id !==null && state[i]?.class_id !==undefined && (state[i]?.class_id == state[state?.length - 5].class_id && state[i]?.children?.id == state[state?.length - 5].children?.id)) ||
           (state[state?.length - 4] && state[i]?.class_id !==null && state[i]?.class_id !==undefined && (state[i]?.class_id == state[state?.length - 4].class_id && state[i]?.children?.id == state[state?.length - 4].children?.id)) ||
           (state[state?.length - 3] && state[i]?.class_id !==null && state[i]?.class_id !==undefined && (state[i]?.class_id == state[state?.length - 3].class_id && state[i]?.children?.id == state[state?.length - 3].children?.id)) ||
           (state[state?.length - 2] && state[i]?.class_id !==null && state[i]?.class_id !==undefined && (state[i]?.class_id == state[state?.length - 2].class_id && state[i]?.children?.id == state[state?.length - 2].children?.id)) ||
           (state[state?.length - 1] && state[i]?.class_id !==null && state[i]?.class_id !==undefined && (state[i]?.class_id == state[state?.length - 1].class_id && state[i]?.children?.id == state[state?.length - 1].children?.id)) 
        ){
          loadingMore = loadingMore + 1;
        }
      }

      if(loadingMore>4){
        getNext();
      }
  }, [state?.length])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { getState() }, [filter, search, showAllRows])

  const setStateExtend = (res, order_id) => setState(prev => prev.map(order => {
    if (order.id !== order_id) return order

    const responseData = res?.data?.data ?? res?.data ?? {}
    const updatedOrder = responseData?.orderPayments?.[0]?.order

    return updatedOrder ? { ...order, ...updatedOrder } : order
  }))
  const columns = [
    {
      width: 300,
      title: <span style={{ background: "var(--color-blue-gray)" }} />,
      dataIndex: "payment_amount",
      key: "payment_amount",
      render: (props) => <SmallCard {...props} />,
    }
  ]
  
  const dataFilter = (mass) => {
    return mass?.filter((el, index, mass)=>{
      let hasAlready = true;
      for(let i=0; i < index; i++) {
        if(mass[i].class_id == el?.class_id && el?.class_id !== null && mass[i].children?.id==el?.children?.id){
          hasAlready = false;
        }
      }
      return hasAlready;
    })
  }
  return <>
    <div className={s.filters}>
      <InputSelect {...bindDirection} />
      <Search {...{ bind: bindSearch, onSubmit: setSearch }} />
      <Button
        className={s.button}
        styles='accent'
        action={() =>setIshShowTable(!isShowTable)}
        >{!isShowTable ? 'Показать сводную таблицу' : 'Скрыть сводную таблицу'}
      </Button>
      <Button
          className={s.button}
          styles='accent'
          action={() =>reset()}
      >{'Сбросить фильтр'}
      </Button>
      <Button
          className={classNames('backgroundNewGrey', 'backgroundNone')}
          action={loadExcel}>
        Выгрузить должников в Excel
      </Button>
    </div>

    {
      isShowTable && 
      <Table
        data={dataFilter(state)}
        Paid={Paid}
        isUniversalBalance={isUniversalBalance}
        setModal={setModal}
        onShowAll={setShowAllRows}
        setState={setState}
        />
    }
    <ul ref={ref} className={s.list}>
      {loadingAll ? (
          <Preloader fullscreen="center" />
      ) : state?.length < 1 ? (
          <p className="empty">Пока ничего нет</p>
      ) : (
          <>
            {dataFilter(state).map(order =>
                    order?.children && (
                        (order.payment_amount !== null ||
                            (order.class_id !== null &&
                                order?.class?.classUser?.filter(classUser => classUser.user_id === order?.children_id && classUser.deleted_at == null)[0]?.amount)) && (
                            <Item
                                key={order.id}
                                order={order}
                                setModal={setModal}
                                setTab={setTab}
                                isUniversalBalance={isUniversalBalance}
                                setState={setState}
                            />
                        )
                    )
            )}
            {loading && <Preloader fillScreen="center" />}
          </>
      )}
    </ul>
    <Modal active={modal.active} setActive={closeModal}>
      {modal.type === 'extend' && <ExtendTraining {...{
        ...modal,
        setModal,
        closeModal,
        setState: e => modal.data?.tariff?.type === 'group_per_lesson'
          ? getState()
          : setStateExtend(e, modal.data.id),
      }} />}
      {modal.type === 'balance' && <ChangeBalance {...{ ...modal, setModal, closeModal, setState: e => setStateExtend(e, modal.data.id) }} />}
    </Modal>
  </>
}


export default ContinuingEducation


const Item = ({ order, setModal, setTab, isUniversalBalance, setState }) => {
  const [comment, setComment] = useState(order.comment);
  const [savedComment, setSavedComment] = useState(order.comment);
  const commentData = order.comment;
  useEffect(() => {
    setComment(commentData);
    setSavedComment(commentData);
  }, [commentData]);
  const addAlert = useAddAlert();
  const saveComment = () => {
    if (comment !== savedComment){
      const data = new FormData();
      const newComment = comment;
      data.append('comment', newComment);
      data.append('id', order.id);
      directionOrdersApi.addComment(data).then(res => {
        if (res?.data?.status !== 'success')
          addAlert({
            title: `УПС! Возникла ошибка... Комментарий не сохранен...`,
            text: '',//res?.message,
            type: 'error'
          });
        else {
          setSavedComment(newComment);
          setState((state) => {
            return state.map((el) => el.id === order.id? { ...order, comment: newComment }: el)
          })
        }
      })
    }
  }
  useEffect(() => {
    const id = setInterval(saveComment, 2000);
    return () => clearInterval(id);
  }, [comment, savedComment])

  return <li className={s.item}>
    <div className={s.head}>
      <div className={classNames('ava', s.ava)}><img src={getAvatar(order.children)} alt="" /></div>
      <h3 className={s.name}>{order?.children?.name ?? 'Не найдено'}</h3>
    </div>
    <div className={s.body}>
      <div className={s.directionContainer}>
        {order.class_id && (
          <div className={s.wrapper}>
            <span className={s.baseTitle}>Класс</span>
            <span className={classNames(s.base)}>
              {order.class?.title ?? ''}
            </span>
          </div>
        )}
        {!order.class_id && (
        <div className={s.wrapper}>
          <span className={s.baseTitle}>Направление</span>
          <span className={classNames(s.base, s.baseTop)}>
            {order?.direction?.name ?? 'Не найдено'}
            <span className={s.tariff}>{order?.tariff?.name ?? 'Не найдено'}</span>
          </span>
        </div>
        )}
        {!isUniversalBalance && <span className={s.base}>
          <Paid {...{order}} />
        </span>}
      </div>

      <div>
        <Textarea
          className={s.orderComment}
          placeholder='Введите комментарий'
          value={comment}
          onChange={(e)=>setComment(e.target.value)}
          />
      </div>

      <div className={s.actions}>
        {isUniversalBalance &&
          <Button action={() => setModal({active: true, type: 'balance', data: order})}>Изменить баланс</Button>
        }
        {!isUniversalBalance && (Number(order?.class?.classUser?.filter(classUser => classUser.user_id === order?.children_id && classUser.deleted_at == null)[0]?.amount) > 0 || (order?.tariff?.id !== undefined && order?.tariff?.type !== 'free') && order.status_payment > 0) && (
            <Button
                className={s.button}
                styles='accent'
                action={() => setModal({active: true, type: 'extend', data: order})}
            >Продлить обучение</Button>
        )}
      </div>
    </div>
  </li>
}

export const Paid = ({ order }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  if (order?.tariff?.type === 'free' && Number(order?.class?.amount) === 0) return 'Бесплатный'
  if (order?.tariff?.type === 'group_per_lesson') {
    return `${Number(order?.buy_hours ?? 0).toFixed(1)} ${declOfNum(order?.buy_hours ?? 0, ['занятие', 'занятия', 'занятий'])} (${order?.payment_amount ?? 0}₽)`
  }
  if (order?.tariff?.type === 'stream_custom_period') return `${declOfNum(order?.buy_months ?? 0, ['оплачен', 'оплачено', 'оплачено'])} ${order?.buy_months ?? 0} ${declOfNum(order?.buy_months ?? 0, ['месяц', 'месяца', 'месяцев'])}`
  if (!usesClassPayment(order)) {
    if (order?.tariff?.type === 'month') return <PaidUpTo {...{ order }} />
    if (order?.tariff?.type === 'hour' || order?.tariff?.type === 'minute') return <PaidHours {...{
      order,
      type: order?.tariff?.type
    }} />
    else if (Number(order?.class?.amount) !== 0) return <PaidHours {...{order, type: order?.tariff?.type}} />
  } else {
    const date = coursePaymentDate(order);
    return date ? 'оплачено до ' + formatDate(date) : 'не оплачено';
  }
  return 'Не найдено'
}

const PaidUpTo = ({ order }) => {
  const date = new Date(order.next_payment_date)
  return order.status_payment ? `оплачено до ${formateDate(date, 'DD.MM.YYYY')}` : 'не оплачено'
}
const PaidHours = ({ order, type }) => {
  if (!order.status_payment) return 'не оплачено'

  if (type === 'hour' || type === 'minute') {
    const balance = Number(order?.private_balance ?? 0)
    return `баланс ${balance.toFixed(2)} руб`
  }

  const buyTimes = billingConversion(order.buy_hours, {type: type}).replaceWithAnAlternative
  const typeBuy = (t) => t === 'minute' ? ['минута', 'минуты', 'минут'] : ['час', 'часа', 'часов']

  if (type === 'minute') {
    const hours = Math.trunc(buyTimes / 60);
    const minutes = +(buyTimes % 60).toFixed(2);

    return `оплачено ${hours} ${declOfNum(hours, typeBuy('hour'))} ${minutes} ${declOfNum(minutes, typeBuy('minute'))} `
  }

  return `оплачено ${buyTimes} ${declOfNum(buyTimes, typeBuy('hour'))}`
}
